<template>
	<div class="de-wrap-content">
		<div class="de-first-row">
			<div class="de-box de-box-first">
				<h2 v-html="translations.deTitle1"></h2>
				<ul>
					<li v-html="translations.deContent1_1"></li>
					<li v-html="translations.deContent1_2"></li>
					<li v-html="translations.deContent1_3"></li>
					<li v-html="translations.deContent1_4"></li>
					<li v-html="translations.deContent1_5"></li>
					<li v-html="translations.deContent1_6"></li>
					<li v-html="translations.deContent1_7"></li>
				</ul>
			</div>
			<div class="de-box de-box-second">
				<h2 v-html="translations.deTitle2"></h2>
				<ul>
					<li v-html="translations.deContent2_1"></li>
					<li v-html="translations.deContent2_2"></li>
				</ul>
				<p v-html="translations.deContent2_3"></p>
				<ul>
					<li v-html="translations.deContent2_4"></li>
					<li v-html="translations.deContent2_5"></li>
					<li v-html="translations.deContent2_6"></li>
				</ul>
			</div>
		</div>
		<div class="de-second-row">
			<div class="de-box de-box-third">
				<h2 v-html="translations.deTitle3"></h2>
				<ul>
					<li v-html="translations.deContent3_1"></li>
					<li v-html="translations.deContent3_2"></li>
					<li v-html="translations.deContent3_3"></li>
					<li v-html="translations.deContent3_4"></li>
					<li v-html="translations.deContent3_5"></li>
				</ul>
			</div>
			<div class="de-box de-box-fourth">
				<h2 v-html="translations.deTitle4"></h2>
				<p>
					<span v-html="translations.deContent4_1_1"></span>
					<a
						v-html="translations.deContent4_1_2"
						href="https://sozialministerium.baden-wuerttemberg.de/de/startseite/"
						target="_blank"
					>
					</a>
				</p>
				<div class="de-wrap-logo">
					<img class="de-logo" src="../assets/LogoMinisterium.png" :alt="$t('deLogoMinistryAlt')" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import i18n from '@/translations/i18n';
export default {
	name: 'Description',
	data() {
		return {
			translations: {},
		};
	},
	computed: {
		computedTranslations: function() {
			return {
				deTitle1: this.$t('deTitle1'),
				deContent1_1: this.$t('deContent1_1'),
				deContent1_2: this.$t('deContent1_2'),
				deContent1_3: this.$t('deContent1_3'),
				deContent1_4: this.$t('deContent1_4'),
				deContent1_5: this.$t('deContent1_5'),
				deContent1_6: this.$t('deContent1_6'),
				deContent1_7: this.$t('deContent1_7'),
				deTitle2: this.$t('deTitle2'),
				deContent2_1: this.$t('deContent2_1'),
				deContent2_2: this.$t('deContent2_2'),
				deContent2_3: this.$t('deContent2_3'),
				deContent2_4: this.$t('deContent2_4'),
				deContent2_5: this.$t('deContent2_5'),
				deContent2_6: this.$t('deContent2_6'),
				deTitle3: this.$t('deTitle3'),
				deContent3_1: this.$t('deContent3_1'),
				deContent3_2: this.$t('deContent3_2'),
				deContent3_3: this.$t('deContent3_3'),
				deContent3_4: this.$t('deContent3_4'),
				deContent3_5: this.$t('deContent3_5'),
				deTitle4: this.$t('deTitle4'),
				deContent4_1_1: this.$t('deContent4_1_1'),
				deContent4_1_2: this.$t('deContent4_1_2'),
			};
		},
	},
	created() {
		this.translations = this.computedTranslations;
		this.hyphenateText();
		window.addEventListener('languageChange', this.languageEvent);
	},
	beforeDestroy() {
		window.removeEventListener('languageChange', this.languageEvent);
	},
	methods: {
		languageEvent() {
			if (i18n.locale !== 'en') this.hyphenateText();
			else this.translations = this.computedTranslations;
		},
		hyphenateText() {
			let that = this;
			this.$global.getHyphenation(this.computedTranslations, function(data) {
				that.translations = data;
			});
		},
	},
};
</script>

<style scoped>
.de-wrap-content {
	width: 100%;
	margin: 50px auto;
	display: flex;
	flex-wrap: wrap;
}

.de-first-row,
.de-second-row {
	display: flex;
	flex: 1 1 0px;
	align-self: stretch;
	min-width: 450px;
}

.de-box {
	flex: 1 1 0px;
	padding: 10px 20px;
	align-self: stretch;
	/* box-shadow: 10px 0px 10px 5px var(--main-color-border-dark); */
}

.de-box-first {
	background-color: #4c7c83aa;
}

.de-box-first:hover {
	background-color: #4c7c83;
}

.de-box-second {
	background-color: #214e56aa;
}

.de-box-second:hover {
	background-color: #214e56;
}

.de-box-third {
	background-color: #3d6c73aa;
}

.de-box-third:hover {
	background-color: #3d6c73;
}

.de-box-fourth {
	background-color: #16606caa;
}

.de-box-fourth:hover {
	background-color: #16606c;
}

h2 {
	cursor: default;
	font-size: 30px;
	color: var(--main-color-highlight);
	font-weight: normal;
	border-bottom: 1px solid var(--main-color-text-light);
	width: fit-content;
	margin: 10px auto;
	padding: 10px 15px 5px 15px;
}

p {
	font-size: 17px;
	color: var(--main-color-text-light);
	margin: 0px 0px 5px 0px;
	cursor: default;
	text-align: justify;
}

b {
	color: var(--secondary-color-highlight);
}

a {
	color: var(--secondary-color-highlight);
	text-decoration: none;
}

a:hover {
	text-decoration: underline;
}

a:visited {
	color: var(--secondary-color-highlight);
}

span {
	text-align: start;
	color: var(--main-color-text-light);
}

ul {
	text-align: start;
	color: var(--main-color-text-light);
}

.de-logo {
	width: 15vw;
	min-width: 100px;
	margin: 30px auto 0px auto;
}

@media (pointer: none), (pointer: coarse) {
	.de-wrap-content {
		width: 100%;
		margin: 50px auto;
		display: block;
	}

	.de-first-row,
	.de-second-row {
		display: block;
		min-width: 0px;
	}
}
</style>
